module.exports = __webpack_public_path__ + "media/icons/bold-54d33dc3.svg";